export default "__VITE_ASSET__DuBmEiQB__"